import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37a13d7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37a13d7c', __exports__)) {
    console.log('reload')
    api.reload('37a13d7c', __exports__)
  }
  
}


export default __exports__